module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"freeCodeCamp","short_name":"fCC","start_url":"/","theme_color":"#0a0a23","background_color":"#fff","display":"minimal-ui","icon":"src/assets/images/square_puck.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6cba562cbd10e31af925a976f3db73f7"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
